import { html } from "lit";
import { OmniElement } from "../../omni-element.js";
import "../omni-style/omni-style.js";
import { css } from "lit";
const styles = css`:host {
  display: inline-block;
}

.dot {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background-color: #99d9ed;
  align-self: flex-end;
}

.dot-container {
  display: flex;
  flex-flow: row;
  width: 6.2857em;
  height: 1.6em;
}

.dot-container > div {
  width: 100%;
  display: flex;
  justify-content: center;
}

.dot-container div:nth-child(1) .dot {
  animation: dotAnimation 1s 0s ease-in infinite;
}

.dot-container div:nth-child(2) .dot {
  animation: dotAnimation 1s 0.25s ease-in infinite;
}

.dot-container div:nth-child(3) .dot {
  animation: dotAnimation 1s 0.5s ease-in infinite;
}

@keyframes dotAnimation {
  0% {
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    background-color: #cbdfee;
  }
  20% {
    transform: translate3d(0, -0.428em, 0) scale3d(1.2857, 1.2857, 1);
    background-color: #19b8e9;
  }
  40% {
    transform: translate3d(0, 0, 0) scale3d(1, 1, 1);
    background-color: #cbdfee;
  }
}`;
class OmniDotLoader extends OmniElement {
  static get styles() {
    return [...super.styles, styles];
  }
  render() {
    return html`
      <omni-style>
        <div class="dot-container">
          <div><div class="dot"></div></div>
          <div><div class="dot"></div></div>
          <div><div class="dot"></div></div>
        </div>
      </omni-style>
    `;
  }
}
OmniElement.register("omni-dot-loader", OmniDotLoader);
export {
  OmniDotLoader
};
//# sourceMappingURL=omni-dot-loader.js.map
